import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "equipement-table"
}
const _hoisted_2 = {
  key: 0,
  class: "radio"
}
const _hoisted_3 = ["aria-label", "checked", "disabled", "indeterminate"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "radio"
}
const _hoisted_7 = {
  key: 1,
  class: "radio"
}
const _hoisted_8 = ["aria-label", "checked", "disabled", "onClick"]
const _hoisted_9 = { class: "item-info" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "noDataTd",
  colspan: "4"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "noDataTd",
  colspan: "4"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  class: "notFoundTd",
  colspan: "4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTableHeader = _resolveComponent("DataTableHeader")!
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_waiting_modal = _resolveComponent("waiting-modal")!
  const _component_equipement_intervention_modal = _resolveComponent("equipement-intervention-modal")!
  const _component_equipement_condition = _resolveComponent("equipement-condition")!
  const _component_EquipementModal = _resolveComponent("EquipementModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.equipements.length === 0 && _ctx.isLoadingEquipements)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                (_ctx.allowSelectAll)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("input", {
                        "aria-label": _ctx.$t('typeSelection.selectionner.tout'),
                        checked: _ctx.isAllSelected,
                        disabled: _ctx.isSelectingAll,
                        indeterminate: _ctx.isPartiallySelected,
                        class: "checkbox",
                        type: "checkbox",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)), ["stop"]))
                      }, null, 8, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (header) => {
                return (_openBlock(), _createBlock(_component_DataTableHeader, {
                  key: header.label,
                  header: header,
                  class: "column",
                  onSort: _ctx.doSort
                }, null, 8, ["header", "onSort"]))
              }), 128))
            ])
          ]),
          (_ctx.equipements.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipements, (equipement) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: equipement.phaseId,
                    class: "pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleSelect(equipement)), ["stop"])
                  }, [
                    _createElementVNode("td", null, [
                      (_ctx.displayRadio)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_RadioBox, {
                              selected: equipement.phaseId === _ctx.selectedEquipement?.phaseId
                            }, null, 8, ["selected"])
                          ]))
                        : (_ctx.multiple)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("input", {
                                "aria-label": _ctx.$t('equipementSelection.search.select'),
                                checked: _ctx.selectedIdsComputed.includes(equipement.phaseId),
                                disabled: _ctx.excludedEquipementIds.includes(String(equipement.id)),
                                class: "checkbox",
                                type: "checkbox",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleMulti(equipement)), ["stop"])
                              }, null, 8, _hoisted_8)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(equipement.libelle), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (equipement.phaseLibelle && equipement.phaseLibelle.trim().toLowerCase() !== 'maintenance')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(equipement.phaseLibelle), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(equipement.groupeLibelle), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(equipement.sousGroupeLibelle), 1)
                      ])
                    ])
                  ], 8, _hoisted_5))
                }), 128)),
                (_ctx.isLoadingEquipements)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('search.isLoading')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.isLoadingEquipements)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('search.isLoading')), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('search.notFound')), 1)
                  ])
                ]))
        ])),
    (_ctx.openModal && _ctx.isLoadingInterventions)
      ? (_openBlock(), _createBlock(_component_waiting_modal, {
          key: 2,
          text: _ctx.$t('equipement.intervention.pending')
        }, null, 8, ["text"]))
      : (_ctx.openModal && _ctx.equipementInterventions.length > 0 && this.step === 2 && !_ctx.openInfoEquipement)
        ? (_openBlock(), _createBlock(_component_equipement_intervention_modal, {
            key: 3,
            equipementInterventions: _ctx.equipementInterventions,
            onCancel: _ctx.cancelInformation,
            onConfirm: _ctx.confirmInformation
          }, null, 8, ["equipementInterventions", "onCancel", "onConfirm"]))
        : (_ctx.openModal && this.step === 1 && !_ctx.openInfoEquipement)
          ? (_openBlock(), _createBlock(_component_equipement_condition, {
              key: 4,
              active: _ctx.openModal && !_ctx.isLoadingInterventions,
              onCancel: _ctx.cancelCondition,
              onConfirm: _ctx.confirm
            }, null, 8, ["active", "onCancel", "onConfirm"]))
          : (_ctx.openModal && _ctx.openInfoEquipement)
            ? (_openBlock(), _createBlock(_component_EquipementModal, {
                key: 5,
                "phase-id": this.phaseId,
                preventif: false,
                onCancel: _ctx.closeModal
              }, null, 8, ["phase-id", "onCancel"]))
            : _createCommentVNode("", true)
  ], 64))
}